import { createSlug } from './create-slug';
import { NUVEM_ENVIO_CARRIERS } from '../pages/constants';

export const isNuvemEnvioPrintLabelAvailable = (carrier: string) => {
  const carrierSlug = createSlug(carrier);
  return NUVEM_ENVIO_CARRIERS.some((substring) =>
    carrierSlug.includes(substring),
  );
};
